import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { EMPTY, Observable, of, throwError} from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { IParticipant } from '@interfaces/interfaces';
import { participantPages } from '../../pages/participant/participants.routes';
import { select, Store } from '@ngrx/store';
import { getAppStateSettings } from 'src/app/store/reducers';
import { ActiveParticipantService } from './active-participant.service';

@Injectable({providedIn: 'root'})
export class ParticipantResolver implements Resolve<IParticipant> {

	constructor(
		private activeParticipantService: ActiveParticipantService,
		private router: Router,
		private store: Store,
	) {
	}

	resolve(): Observable<IParticipant> {

		return this.store.pipe(
			select(getAppStateSettings),
			switchMap(state => state.activeProjectID ? of(state) : throwError('no active project found')),
			// eslint-disable-next-line
			catchError(err => {
				console.warn('TODO Alert Toast', err);
				this.router
					.navigate([participantPages.dashboard.base()])
					.catch(console.error);

				return EMPTY;
			}),
			switchMap(state => state.activeParticipantID ?
				of(state.activeParticipantID) :
				throwError('no active participant found')
			),
			// eslint-disable-next-line
			catchError(err => {
				console.warn('TODO Alert Toast', err);
				this.router
					.navigate([participantPages.dashboard.base()])
					.catch(console.error);

				return EMPTY;
			}),
			switchMap(activeParticipantID => this.activeParticipantService.participant$.pipe(
				filter(participant => participant && participant.id === activeParticipantID),
			)),
			take(1),
		);
	}
}
